import { debounce } from 'lodash'
/**
 * 监听屏幕大小变化修改 根元素 的font-size
 */
export default {
  computed: {
    mobileDevice: {
      get() {
        return this.$store.state.mobileDevice
      },
      set(val) {
        this.$store.commit('set_mobileDevice', val)
      }
    }
  },
  data() {
    return {
      baseWidth: 1440,
      baseSize: 16,
      cacheSize: ''
    }
  },
  mounted() {
    this.__resizeHandler = debounce(this.resetFontSize, 100)
    this.htmlElm = document.documentElement
    this.cacheSize = this.htmlElm.style.fontSize
    this.resetFontSize()
    window.addEventListener('resize', this.__resizeHandler)
  },
  beforeDestroy() {
    this.htmlElm.style.fontSize = this.cacheSize
    window.removeEventListener('resize', this.__resizeHandler)
  },
  methods: {
    resetFontSize() {
      const clientWidth = window.innerWidth
      // 这是有两套根据不同设备的ui
      const mobileDesignWidth = 750
      const desktopDesignWidth = 1950
      // const designWidth = 750
      if (clientWidth > mobileDesignWidth) {
        // 桌面端
        const radio = desktopDesignWidth / 100 // 设计图宽度/100
        // 添加一个补偿值
        const a = (desktopDesignWidth - clientWidth) * 0.5
        this.htmlElm.style.fontSize = (clientWidth + a) / radio + 'px'
        // this.htmlElm.style.fontSize = '100px'

        this.mobileDevice = false
      } else {
        // 移动端
        const radio = mobileDesignWidth / 100 // 设计图宽度/100
        this.htmlElm.style.fontSize = clientWidth / radio + 'px'

        this.mobileDevice = true
      }
    }
  }
}
